import IconButton from '@mui/material/IconButton';
import { styled as muiStyled } from '@mui/material/styles';

export const StyledCloseButton = muiStyled(IconButton)(() => ({
  position: 'absolute',
  right: 0,
  top: 0,
  color: 'inherit',
}));
